import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getRapidboardResources } from '@jira/router-resources__classic-projects/src/getRapidboardResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { AGGRESSIVE_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import {
	getNavigationResources,
	getUserBoardNavigationResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { rapidboardUserReportRoute } from '@jira/router-routes__classic-projects-routes/src/rapidboardUserReportRoute.tsx';
import { ClassicReportSkeleton } from '@jira/platform__skeletons/src/ui/classic-report/ClassicReportSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import { reportPageEntrypoint } from './ui/reportPageEntrypoint.tsx';

export const rapidboardUserReportRouteEntry: Route = createEntry(rapidboardUserReportRoute, () => ({
	group: 'classic-software',
	skeleton: ClassicReportSkeleton,
	layout: genericProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getNavigationResources(),
		...getIssueViewResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		...getRapidboardResources(),
		...getReportsCommonResource(),
		...getUserBoardNavigationResources(),
	],

	afterPaint: [LazyIssueApp],
	entryPoint: () => reportPageEntrypoint,

	earlyAssets: AGGRESSIVE_EARLY_ASSET_STRATEGY,
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
